import partnerLogo1 from "@/assets/newHome/01.png";
import partnerLogo2 from "@/assets/newHome/02.png";
import partnerLogo3 from "@/assets/newHome/03.png";
import partnerLogo4 from "@/assets/newHome/04.png";
import partnerLogo5 from "@/assets/newHome/05.png";
import partnerLogo6 from "@/assets/newHome/06.png";
import partnerLogo7 from "@/assets/newHome/07.png";
import partnerLogo8 from "@/assets/newHome/08.png";
import partnerLogo9 from "@/assets/newHome/09.png";
import partnerLogo10 from "@/assets/newHome/10.png";
import partnerLogo11 from "@/assets/newHome/11.png";
import partnerLogo12 from "@/assets/newHome/12.png";
import partnerLogo13 from "@/assets/newHome/13.png";
import partnerLogo14 from "@/assets/newHome/14.png";
import partnerLogo15 from "@/assets/newHome/15.png"
import partnerLogo16 from "@/assets/newHome/16.png";
import partnerLogo17 from "@/assets/newHome/17.png";
import partnerLogo18 from "@/assets/newHome/18.png";
import partnerLogo19 from "@/assets/newHome/19.png";
import partnerLogo20 from "@/assets/newHome/20.png";
import partnerLogo21 from "@/assets/newHome/21.png";
import partnerLogo22 from "@/assets/newHome/22.png";
import partnerLogo23 from "@/assets/newHome/23.png";

export const Partners = (): JSX.Element => {
  const partnerLogos = [
    { src: partnerLogo1, alt: "Partner Company 1" },
    { src: partnerLogo2, alt: "Partner Company 2" },
    { src: partnerLogo3, alt: "Partner Company 3" },
    { src: partnerLogo4, alt: "Partner Company 4" },
    { src: partnerLogo5, alt: "Partner Company 5" },
    { src: partnerLogo6, alt: "Partner Company 6" },
    { src: partnerLogo7, alt: "Partner Company 7" },
    { src: partnerLogo8, alt: "Partner Company 8" },
    { src: partnerLogo9, alt: "Partner Company 9" },
    { src: partnerLogo10, alt: "Partner Company 10" },
    { src: partnerLogo11, alt: "Partner Company 11" },
    { src: partnerLogo12, alt: "Partner Company 12" },
    { src: partnerLogo13, alt: "Partner Company 13" },
    { src: partnerLogo14, alt: "Partner Company 14" },
    { src: partnerLogo15, alt: "Partner Company 15" },
    { src: partnerLogo16, alt: "Partner Company 16" },
    { src: partnerLogo17, alt: "Partner Company 17" },
    { src: partnerLogo18, alt: "Partner Company 18" },
    { src: partnerLogo19, alt: "Partner Company 19" },
    { src: partnerLogo20, alt: "Partner Company 20" },
    { src: partnerLogo21, alt: "Partner Company 21" },
    { src: partnerLogo22, alt: "Partner Company 22" },
    { src: partnerLogo23, alt: "Partner Company 23" },
  ];
  const half = Math.floor(partnerLogos.length / 2);
const firstHalf = partnerLogos.slice(0, half);
const secondHalf = partnerLogos.slice(half);
  return (
    <section className="w-full py-6 bg-white overflow-hidden">
    {/* Top row - Left to Right */}
    <div className="relative w-full h-[100px]">
      <div className="absolute top-0 left-0 flex animate-scrollRight space-x-10">
        {[...firstHalf, ...firstHalf].map(
          (logo, index) => (
            <div
              key={`right-${index}`}
              className="min-w-[160px] h-[100px] flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </div>
          )
        )}
      </div>
    </div>
  
    {/* Bottom row - Right to Left */}
    <div className="relative w-full h-[100px] mt-6">
      <div className="absolute top-0 left-0 flex animate-scrollLeft space-x-10">
        {[...secondHalf, ...secondHalf].map(
          (logo, index) => (
            <div
              key={`left-${index}`}
              className="min-w-[160px] h-[100px] flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </div>
          )
        )}
      </div>
    </div>
  </section>
  
  );
};
